import React from "react";

function Opera() {
  return (
    <div>
      <h3>Enabling Safari Location Services (Opera)</h3>
      <ol>
        <li>
          Go to&nbsp;<strong>Settings</strong>.
        </li>
        <li>
          Click&nbsp;<strong>Advanced</strong>&nbsp;in the left sidebar, and
          click&nbsp;<strong>Privacy &amp; security</strong>.
        </li>
        <li>
          Under&nbsp;<strong>Privacy and security</strong>, click&nbsp;
          <strong>Site settings</strong>.
        </li>
        <li>
          Click&nbsp;<strong>Location</strong>.
        </li>
        <li>
          At the top, turn on or off&nbsp;
          <strong>Ask before accessing (recommended)</strong>.
        </li>
      </ol>
    </div>
  );
}

export default Opera;
